var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import "whatwg-fetch"; // polyfill for IE11 (todo: is this required?)
export class BaseRemoteService {
    constructor(apiRoot, authService) {
        this.apiRoot = apiRoot;
        this.authService = authService;
    }
    getRequest(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(url, {
                method: "GET",
            });
        });
    }
    postRequest(url, model) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(url, {
                method: "POST",
                body: JSON.stringify(model),
                headers: {
                    "Content-Type": "application/json",
                },
            });
        });
    }
    postRequestFormData(url, model = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = this.modelToFormData(model);
            return yield this.fetch(url, {
                method: "POST",
                body: formData,
            });
        });
    }
    patchRequest(url, patchDocument) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(url, {
                method: "PATCH",
                body: JSON.stringify(patchDocument),
                headers: {
                    "Content-Type": "application/json",
                },
            });
        });
    }
    getRequestBlob(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchBlob(url, {
                method: "GET",
            });
        });
    }
    deleteRequest(url) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetchNoContent(url, {
                method: "DELETE",
            });
        });
    }
    fetchBlob(url, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.authService) {
                    this.authService.attachAuth(opts);
                }
                const response = yield fetch(url, opts);
                if (response.ok) {
                    return yield response.blob();
                }
                else {
                    // for the time being treat unhappy responses as an exception (including 401s etc)
                    throw response;
                }
            }
            catch (err) {
                throw err;
            }
        });
    }
    fetchNoContent(url, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.authService) {
                this.authService.attachAuth(opts);
            }
            const response = yield fetch(url, opts);
            if (!response.ok) {
                throw response;
            }
        });
    }
    fetch(url, opts = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const processPotentiallyEmptyResponse = (response) => __awaiter(this, void 0, void 0, function* () {
                const responseText = yield response.text();
                const responseObject = (responseText === null || responseText === void 0 ? void 0 : responseText.length) ? JSON.parse(responseText) : null;
                return responseObject;
            });
            try {
                if (this.authService) {
                    this.authService.attachAuth(opts);
                }
                const response = yield fetch(url, opts);
                if (response.ok) {
                    return processPotentiallyEmptyResponse(response);
                }
                else {
                    // for the time being treat unhappy responses as an exception (including 401s etc)
                    throw response;
                }
            }
            catch (err) {
                throw err;
            }
        });
    }
    modelToFormData(model) {
        const formData = new FormData();
        for (const key in model) {
            const value = model[key];
            if (value) {
                // if this is a FileList or array of file(s) being uploaded, have to unpack it differently
                if (value.length && Number.isInteger(value.length) && value[0] instanceof File) {
                    Array.from(value).forEach(item => formData.append(key, item));
                }
                else {
                    formData.append(key, value);
                }
            }
        }
        return formData;
    }
}
